/* eslint-disable */
// import React, { useState } from 'react';
// import Select from 'react-select';
// import DashboardSection from '../../DashboardContainer/DashboardSection';
// import DomainTile from '../../DomainTile/DomainTile';
// import ReusableTable from '../../ReusableTable/ReusableTable';
// import styles from './DeatiledPageComp.module.css';
// import './DeatiledPageComp.css';

// const geographyOptions = [
//   { value: 'All', label: '(All)' },
//   { value: 'domastic', label: 'Domastic' },
//   { value: 'international', label: 'International' },
// ];

// const yearOptions = [
//   { value: 'All', label: '(All)' },
//   { value: '2025', label: '2025' },
//   { value: '2024', label: '2024' },
// ];

// const quarterOptions = [
//   { value: 'All', label: '(All)' },
//   { value: 'Q1', label: 'Q1' },
//   { value: 'Q2', label: 'Q2' },
//   { value: 'Q3', label: 'Q3' },
//   { value: 'Q4', label: 'Q4' },
// ];

// const monthOptions = [
//   { value: 'All', label: '(All)' },
//   { value: 'Jan', label: 'Jan' },
//   { value: 'Feb', label: 'Feb' },
//   { value: 'Mar', label: 'Mar' },
//   { value: 'Apr', label: 'Apr' },
//   { value: 'May', label: 'May' },
//   { value: 'Jun', label: 'Jun' },
//   { value: 'Jul', label: 'Jul' },
//   { value: 'Aug', label: 'Aug' },
//   { value: 'Sep', label: 'Sep' },
//   { value: 'Oct', label: 'Oct' },
//   { value: 'Nov', label: 'Nov' },
//   { value: 'Dec', label: 'Dec' },
// ];

// const ComplainceDrilldown = () => {
//   const [year, setYear] = useState(yearOptions[0]);
//   const [quarter, setQuarter] = useState(quarterOptions[0]);
//   const [month, setMonth] = useState(monthOptions[0]);

//   const [totalRecords, setTotalRecords] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [page, setPage] = useState(1); 
//   const itemsPerPage = 10;
//   const [selectedPage, setSelectedPage] = useState(1);

//   const handleApply = () => {
//     console.log('Apply clicked with:', {
//       year: year.value,
//       quarter: quarter.value,
//       month: month.value,
//     });
//   };

//   const handleCSVDownload = () => {
//     const csvHeader = columns.map(col => col.header).join(',');
//     const csvRows = data.map(row =>
//       columns.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
//     );
//     const csvContent = [csvHeader, ...csvRows].join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.download = 'legal_disputes.csv';
//     link.click();
//   };

//   const handleReset = () => {
//     setYear(yearOptions[0]);
//     setQuarter(quarterOptions[0]);
//     setMonth(monthOptions[0]);
//   };

//   const columns = [
//     { header: "Sr. No.", accessor: "srNo" },
//     { header: "Complaints/Disputes Name", accessor: "name" },
//     { header: "Domestic/International", accessor: "type" },
//     { header: "Status", accessor: "status" },
//     { header: "Comments", accessor: "comments" }
//   ];

//   const data = [
//     { "srNo": 1, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 2, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 3, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 4, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 5, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 6, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 7, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 8, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 9, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 10, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 11, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 12, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 13, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 14, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//     { "srNo": 15, "name": "Trademark A", "type": "Domestic", "status": "Open", "comments": "Pending hearing" },
//     { "srNo": 16, "name": "Trademark B", "type": "International", "status": "Closed", "comments": "Resolved" },
//   ];

//   const handlePageChange = (page) => {
//     setSelectedPage(page);
//     console.log(`Selected page: ${page}`);
//   };

//   const [dataLoading, setdataLoading] = useState(false);

//   return (
//     <>
//       <div className={styles.filter_panel_container}>
//         <div className={styles.filter_panel_row}>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Geography</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={year}
//                 onChange={setYear}
//                 options={geographyOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Year</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={year}
//                 onChange={setYear}
//                 options={yearOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Quarter</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={quarter}
//                 onChange={setQuarter}
//                 options={quarterOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className={styles.filter_panel_col}>
//             <label className={styles.filter_label}>Month</label>
//             <div className={styles.filter_select_wrapper}>
//               <Select
//                 value={month}
//                 onChange={setMonth}
//                 options={monthOptions}
//                 isSearchable={false}
//               />
//             </div>
//           </div>
//           <div className="filter-panel-col action-buttons">
//             <button onClick={handleApply} className="btn apply-btn">
//               Apply
//             </button>
//             <button onClick={handleReset} className="btn reset-btn">
//               Reset
//             </button>
//           </div>
//         </div>
//       </div>
//       <div>
//         <div className="row">
//           <div className="col-md-12">
//             <DomainTile title='Domain complaints/disputes Status' showBackButton={true}/>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-md-12">
//             <DashboardSection title="" disableDetailView={true} detailPath="/Legal-Page/Domain-Registrations-Related-Matters">
//               {/* <h2> tabel here</h2> */}
//               <ReusableTable
//                 data={data} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading}
//               />
//             </DashboardSection>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ComplainceDrilldown;

// ####################### New Pages ##############################
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import config from '../../../config/config';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import DomainTile from '../../DomainTile/DomainTile';
import ReusableTable from '../../ReusableTable/ReusableTable';
import styles from './DeatiledPageComp.module.css';
import './DeatiledPageComp.css';

const { API_BASE_URL } = config;

const quarterOptions = [
  { value: 'All', label: '(All)' },
  { value: 'Q1', label: 'Q1' },
  { value: 'Q2', label: 'Q2' },
  { value: 'Q3', label: 'Q3' },
  { value: 'Q4', label: 'Q4' },
];

const ComplainceDrilldown = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const initialFilters = location.state || {
    entityData: [],
    geographyData: null,
    yearData: null,
    monthData: null,
    quarterData: null,
  };

  const [hasApplied, setHasApplied] = useState(false);
  
  const [filters, setFilters] = useState(initialFilters);

  // console.log("data test treadmark--------------->", entityData, geographyData, yearData, quarterData, monthData);

  const [entityOptions, setEntityOptions] = useState([]);
  const [geographyOptions, setGeographyOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  // const [entity, setEntity] = useState(entityOptions[0]);
  const [entity, setEntity] = useState([]);
  const [geography, setGeography] = useState(geographyOptions[0]);
  const [year, setYear] = useState(yearOptions[0]);
  const [month, setMonth] = useState(monthOptions[0]);
  const [quarter, setQuarter] = useState(quarterOptions[0]);

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1); 
  const itemsPerPage = 10;
  const [selectedPage, setSelectedPage] = useState(1);

  const [data, setData] = useState([]);

  const fetchData = (filters) => {
    console.log("Fetching with", filters);
  };

  useEffect(() => {
    // fetch data using filters
    fetchData(filters);
  }, []);


  // const handleEntityChange = (selected) => {
  //   setEntity(selected);
  //   setFilters(prev => ({ ...prev, entityData: selected }));
  // };

  const handleEntityChange = (selected) => {
    setEntity(selected || []);
    setFilters((prev) => ({ ...prev, entityData: selected || [] }));
  };

  const handleGeographyChange = (selected) => {
    setGeography(selected);
    setFilters(prev => ({ ...prev, geographyData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters(prev => ({ ...prev, yearData: selected }));
  };

  const handleMonthChange = (selected) => {
    setMonth(selected);
    setFilters(prev => ({ ...prev, monthData: selected }));
  };

  const handleQuarterChange = (selected) => {
    setQuarter(selected);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const handleApply = () => {
    // const entityFilter = filters.entityData.value || '';
    const entityFilter = entity.map(e => e.value);
    const geographyFilter = geography?.value === 'All' ? '' : geography?.value || '';
    const yearFilter = year?.value === 'All' ? '' : year?.value || '';
    const monthFilter = month?.value === 'All' ? '' : month?.value || '';
    const page = selectedPage || 1;
    const limit = itemsPerPage;
    const offset = (page - 1) * limit;

    const fetchDomainCompData = async () => {
      setdataLoading(true);
      try {
        const response = await axios.post(`${API_BASE_URL}/api/legal-Domain-Complaints`, 
          {
            entity: entityFilter,
            domestic: geographyFilter,
            year: yearFilter,
            month: monthFilter,
            limit: limit,
            offset: offset,
          },
          {
            headers: {
              Authorization: 'Basic YWRtaW4xOjEyMw==',
            },
          }
        );

        console.log("Trademark data received:", response.data);
        setData(response.data.data);
        setTotalRecords(response.data.total);
      } catch (error) {
        console.error('Error fetching trademark data:', error);
      } finally {
        setdataLoading(false);
      }
    };

    fetchDomainCompData();
  };


  const handleCSVDownload = async () => {
    try {
      const entityFilter = entity.map(e => e.value);
      const geographyFilter = geography?.value === 'All' ? '' : geography?.value || '';
      const yearFilter = year?.value === 'All' ? '' : year?.value || '';
      const monthFilter = month?.value === 'All' ? '' : month?.value || '';
      const bodyData = {
        entity: entityFilter,
        domestic: geographyFilter,
        year: yearFilter,
        month: monthFilter,
      };

      const response = await fetch(`${API_BASE_URL}/api/legal-Domain-Complaints-Download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        throw new Error("Failed to download CSV");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "domain_complaints_data.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const handleReset = () => {
    setEntity([]);
    setGeography(null);
    setYear(null);
    setQuarter(null);
    setMonth(null);
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-entity`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setEntityOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchGeoOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-geography`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setGeographyOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setYearOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/legal-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
      .then((response) => {
        setMonthOptions(response.data);
      })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchGeoOptions();
    fetchYearOptions();
    fetchMonthOptions();
  }, []);

  useEffect(() => {
    console.log("test log -------------->",entityOptions.length, geographyOptions.length, yearOptions.length, monthOptions.length);
    
    if (entityOptions.length && geographyOptions.length && yearOptions.length && monthOptions.length) {
      // if (filters.entityData) {
      //   const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
      //   if (ent) setEntity(ent);
      // }
      if (filters.entityData?.length) {
        const ents = entityOptions.filter(opt =>
          filters.entityData.some(f => f.value === opt.value)
        );
        setEntity(ents);
      }

      if (filters.geographyData) {
        const geo = geographyOptions.find(opt => opt.value === filters.geographyData.value);
        if (geo) setGeography(geo);
      }

      if (filters.yearData) {
        const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        if (yr) setYear(yr);
      }

      if (filters.monthData) {
        const mon = monthOptions.find(opt => opt.value === filters.monthData.value);
        if (mon) setMonth(mon);
      }

      if (filters.quarterData) {
        const qtr = quarterOptions.find(opt => opt.value === filters.quarterData.value);
        if (qtr) setQuarter(qtr);
      }

      console.log("selectd data dropdown ----------------->", entity, geography, year, month);

      setHasApplied(true);
      // if (entity) {
      //   setTimeout(() => {
      //     handleApply();
      //   }, 1000);
      // }
    }
  }, [entityOptions, geographyOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true && filters.entityData !== null) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);


  const columns = [
    { header: "Complaints/Disputes Name", accessor: "complaints_disputes_name" },
    { header: "Domestic/International", accessor: "domestic_international" },
    { header: "Status", accessor: "complaints_status" },
    { header: "Comments", accessor: "complaints_comments" }
  ];


  const handlePageChange = (page) => {
    setSelectedPage(page);
    setCurrentPage(page);
    handleApply();
  };

  const [dataLoading, setdataLoading] = useState(false);

  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 3000,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 3000,
    }),
  };

  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                isMulti
                value={entity}
                // onChange={setEntity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={false}
                placeholder="Select Entity"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Geography</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={geography}
                // onChange={setGeography}
                onChange={handleGeographyChange}
                options={geographyOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                // onChange={setYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                // onChange={setMonth}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                // onChange={setQuarter}
                onChange={handleQuarterChange}
                options={quarterOptions}
                isSearchable={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-md-12">
            <DomainTile title='Domain complaints/disputes Status' showBackButton={true} mainPagePath="/Legal-Page" detailState = {filters}/>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              {/* <h2> tabel here</h2> */}
              <ReusableTable
                data={data} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={totalRecords} handleCSVDownload={handleCSVDownload} dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComplainceDrilldown;

